import { useParams } from 'react-router-dom';
import { ThumbsUp } from 'lucide-react';

import { useCoachActivity } from '@/data/coachActivity';
import { convertToDateFormat } from '@/helpers/dateHelpers';

import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

import { COACH_ACTIVITY_STATUS } from '../enums';

const ApprovedCoachContractMessage = () => {
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);

  if (coachActivity.data.status !== COACH_ACTIVITY_STATUS.APPROVED) {
    return null;
  }

  return (
    <div className="mb-6">
      <Alert>
        <ThumbsUp className="h-4 w-4" />
        <AlertTitle>Coach Approved</AlertTitle>
        <AlertDescription>
          This coach was approved on{' '}
          {convertToDateFormat(coachActivity.data.approvedAt)} by{' '}
          {coachActivity.data.approvedBy?.firstname}{' '}
          {coachActivity.data.approvedBy?.lastname}.
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default ApprovedCoachContractMessage;
